import { useState } from "react";
import { Requirement } from "../../types/requirement.response";
import { AddableCourse, CourseLite, CourseOption, CourseSummary } from "../../types/course.response";
import { ProgramInfo } from "../../types/program.response";
import { CourseRequirementOverride } from "../../services/api/user-courses.api";
import { DEFAULT_SEMESTER } from "../../constants";
import RequirementDetailList from "./ListReqDetail";
import RequirementDetailGroup from "./GroupReqDetail";
import RequirementDetailOption from "./OptionReqDetail";
import RequirementDetailOptionGroup from "./OptionGroupReqDetail";
import FilterToggle from "./FilterToggle";

interface RequirementDetailProps {
    programInfo: ProgramInfo;
    requirement: Requirement;
    coursesMap: Record<string, CourseSummary>;
    isSliceLoaded: boolean;
    handleAddCourse: (newCourse: AddableCourse, overrides: CourseRequirementOverride[], semester: string | null, classSectionIds?: number[]) => void;
    handleDeleteCourse: (deletedCourse: CourseLite) => void;
    handleFavoriteCourse: (courseOption: CourseLite) => void;
    optimisticFavorites: Map<string, boolean>;
    userCourses?: CourseOption[];
}

export default function RequirementDetail({
    programInfo,
    requirement,
    coursesMap,
    isSliceLoaded,
    handleAddCourse,
    handleDeleteCourse,
    handleFavoriteCourse,
    optimisticFavorites,
    userCourses,
}: RequirementDetailProps) {
    const [hideUnavailable, setHideUnavailable] = useState(false);

    const detailProps = {
        programInfo,
        requirement,
        coursesMap,
        isSliceLoaded,
        handleAddCourse,
        handleDeleteCourse,
        handleFavoriteCourse,
        optimisticFavorites,
        userCourses,
        hideUnavailable,
    };

    const toggleFilter = () => setHideUnavailable(h => !h);

    const renderRequirementContent = () => {
        switch (requirement.info.uiType) {
            case "LIST":
                return (
                    <>
                        <div className="flex justify-end mt-4">
                            <FilterToggle active={hideUnavailable} onToggle={toggleFilter} semester={DEFAULT_SEMESTER} />
                        </div>
                        <table className="w-full border-collapse mt-2">
                            <tbody><RequirementDetailList {...detailProps} /></tbody>
                        </table>
                    </>
                );
            case "GROUP":
                return (
                    <>
                        <div className="flex justify-end">
                            <FilterToggle active={hideUnavailable} onToggle={toggleFilter} semester={DEFAULT_SEMESTER} />
                        </div>
                        <table className="w-full border-collapse mt-2">
                            <tbody><RequirementDetailGroup {...detailProps} /></tbody>
                        </table>
                    </>
                );
            case "OPTION":
                return <RequirementDetailOption {...detailProps} onToggleFilter={toggleFilter} />;
            case "OPTION_GROUP":
                return <RequirementDetailOptionGroup {...detailProps} onToggleFilter={toggleFilter} />;
            default:
                return null;
        }
    };

    return (
        <div className="bg-white">
            {renderRequirementContent()}
        </div>
    );
}
